import { startCustomDriver, Config } from '@/components/float-btn/recorder/guide/customDriver';
import { useRootInstance } from 'common-module/src/util/useRootInstance';
import { waitGetAny } from '@zk/framework-vue';

let currentConfig: any;
let currentGuideIndex: number = 0;
let guide: any;
let newGuideKey: string;
let newGuideName: string;

export const STEP_CONFIG: Config[] = [
  {
    selector: 'generateSubtask',
    getElement: async() => {
      return await waitGetAny(() => {
        return (document.querySelector('.zk-issue-detail-left-navigation-label [data-code="subtask:recommend"]')
        || document.querySelector('.zk-issue-detail-field-subtask .add-button-label .add-recommend-btn')) as HTMLElement;
      }, { interval: 50, timeout: 5000 });
    },
    scopeName: 'generate-subtask-btn',
    clickToNext: true,
    popover: {
      title: 't(userGuide.generateSubtask.title)',
      description: 't(userGuide.generateSubtask.desc1)',
      position: 'bottom-right'
    },
    addScopeCss: (name: string) => {
      return `
      .${name} .el-drawer__wrapper {
        position: absolute;
        z-index: auto !important;
      }
      .${name} .driver-highlighted-element {
        background-color: #fff !important;
      }
      `;
    }
  },
  {
    selector: '[class^="SubtaskGenerateList_item"]',
    getElement: async() => {
      return await waitGetAny(() => {
        return document.querySelector('[class^="SubtaskGenerateList_item"]') as HTMLElement;
      }, { interval: 50, timeout: 10000 });
    },
    scopeName: 'generate-subtask-item',
    clickToNext: true,
    popover: {
      title: 't(userGuide.generateSubtask.title)',
      description: 't(userGuide.generateSubtask.desc2)',
      position: 'top-right'
    },
    addScopeCss: (name: string) => {
      return `
      .${name} .el-drawer__wrapper {
        position: absolute;
        z-index: auto !important;
      }
      .${name} .driver-highlighted-element {
        background-color: #fff;
      }
      .${name} .driver-highlighted-element .zk-issue-detail-subtask-summary__edit-icon{
        display: inline-flex;
      }
      `;
    }
  },
  {
    selector: '.generate-subtask-button-warp',
    scopeName: 'generate-subtask-confirm',
    popover: {
      title: 't(userGuide.generateSubtask.title)',
      description: 't(userGuide.generateSubtask.desc3)',
      position: 'top-center'
    },
    clickToClose: true,
    addScopeCss: (name: string) => {
      return `
      .${name} .el-drawer__wrapper {
        position: absolute;
        z-index: auto !important;
      }
      `;
    },
    beforeCreateDriver: async() => {
    }
  }
];

async function awaitOpenIssueDetail(instance: any, issueData: {id: number, [key:string]: any}) {
  return new Promise(
    (resolve, reject) => {
      instance.eventBus.$emit('issue:edit', issueData || {});
      instance.eventBus.$on('issue:closed', reject);
      waitGetAny(() => {
        return document.querySelector('.zk-issue-detail-field-description');
      }, { interval: 50, timeout: 10000 }).then(resolve).catch(reject).finally(
        () => {
          instance.eventBus.$off('issue:closed', reject);
        }
      );
    }
  );
}

export async function startSubtaskGuide(guideKey: string, guideName: string, issueData: {id: number}) {
  if (!guideKey) {
    return;
  }
  const instance = useRootInstance();
  if (!issueData?.id) {
    instance.$message.warning(instance.$t('userGuide.generateSubtask.deleteTip'));
    return;
  }
  // 打开详情
  await awaitOpenIssueDetail(instance, issueData);
  newGuideKey = guideKey;
  newGuideName = guideName;
  currentConfig = STEP_CONFIG;
  startGuide(0);
}


const toNext = () => {
  if (currentGuideIndex === currentConfig.length - 1) {
    finishNewGuide();
    onClose();
    return;
  }
  currentGuideIndex++;
  startGuide(currentGuideIndex);
};

async function finishNewGuide() {
  const instance = useRootInstance();
  instance.eventBus.$emit('finish-guide-task', newGuideKey);
}

function getCurrentStepConfig (index: number) {
  const stepConfig: any = currentConfig[index];
  const total = Object.keys(STEP_CONFIG).length;
  const progress = `${index + 1} / ${total}`;
  stepConfig.progress = progress;
  return stepConfig;
}

function onIssueClose() {
  guide?.stop();
}

function initEventListener() {
  const instance = useRootInstance();
  instance.eventBus.$on('issue:closed', onIssueClose);
}

function offEventListener() {
  const instance = useRootInstance();
  instance.eventBus.$off('issue:closed', onIssueClose);
}

function clear() {
  currentGuideIndex = 0;
  guide = null;
  newGuideKey = '';
  newGuideName = '';
  offEventListener();
}

const onClose = () => {
  if (!guide) {
    return;
  }
  const instance = useRootInstance();
  const isLast = currentGuideIndex === currentConfig.length - 1;
  instance.$track.send('Guide_DoneTask', { task_name: newGuideName, finish: isLast }, true);
  clear();
};

async function startGuide(index: number) {
  currentGuideIndex = index;
  const stepConfig = getCurrentStepConfig(index);
  if (!stepConfig) {
    return;
  }
  const instance = useRootInstance();
  guide = await startCustomDriver(
    {
      config: stepConfig,
      onNext: toNext,
      onClose: onClose
    },
    instance
  );
  offEventListener();
  initEventListener();
}
